export enum AGENT_HUB_AGENTS {
    /**
     * @value Add starter
     * @description Label of the button adding conversation starters fields in the Agent Hub admin
     */
    ADD_STARTER = 'AGENT_HUB_SEARCH.ADD_STARTER',
    /**
     * @value Agent Card URL
     * @description Label for the Agent Card URL field in the Connection section of the external A2A agent creation/edition form.
     */
    AGENT_CARD_URL = 'AGENT_HUB_AGENTS.AGENT_CARD_URL',
    /**
     * @value Paste the Agent Card URL provided by the platform where this agent is hosted. LumApps will automatically discover the agent's capabilities and connection details.
     * @description Helper text under the Agent Card URL field in the external A2A agent creation/edition form, explaining what the Agent Card URL is used for.
     */
    AGENT_CARD_URL_HELPER = 'AGENT_HUB_AGENTS.AGENT_CARD_URL_HELPER',
    /**
     * @value Agent Library description
     * @description Label for the field in the agent creation and edition form to set up the agent's description that will be shown in the agent library.
     */
    AGENT_LIBRARY_DESCRIPTION = 'AGENT_HUB_AGENTS.AGENT_LIBRARY_DESCRIPTION',
    /**
     * @value Shown to employees in the Agent Library to explain what this agent can help them do.
     * @description Helper shown under the "Agent Library description" field to explain where it will be displayed.
     */
    AGENT_LIBRARY_DESCRIPTION_HELPER = 'AGENT_HUB_AGENTS.AGENT_LIBRARY_DESCRIPTION_HELPER',
    /**
     * @value Example: Get answers about payroll, benefits, leave, and company policies.
     * @description Placeholder shown on the Agent Library description field of the agent creation and edition form.
     */
    AGENT_LIBRARY_DESCRIPTION_PLACEHOLDER = 'AGENT_HUB_AGENTS.AGENT_LIBRARY_DESCRIPTION_PLACEHOLDER',
    /**
     * @value This setting locks after publishing. You cannot edit the agent type later.
     */
    AGENT_TYPE_DESCRIPTION = 'AGENT_HUB_SEARCH.AGENT_TYPE_DESCRIPTION',
    /**
     * @value AI Agents
     * @description Filter used in agent library to displayed external agents + agents with tools
     */
    AI_AGENTS = 'AGENT_HUB_SEARCH.AI_AGENTS',
    /**
     * @value AI Search Assistants
     * @description Used to sort all ask ai related search assistant. Displayed in agent library's filter
     */
    AI_SEARCH_ASSISTANTS = 'AGENT_HUB_SEARCH.AI_SEARCH_ASSISTANTS',
    /**
     * @value Set up how LumApps connects to your external agent using its Agent Card
     * @description Description of the Connection section in the external A2A agent creation/edition form.
     */
    CONNECTION_DESCRIPTION = 'AGENT_HUB_AGENTS.CONNECTION_DESCRIPTION',
    /**
     * @value Connect a third-party agent
     * @description Label for the "Connect a third-party agent" (A2A) option in the "What do you want to build?" agent type radio group of the agent creation form.
     */
    CONNECT_THIRD_PARTY_AGENT = 'AGENT_HUB_AGENTS.CONNECT_THIRD_PARTY_AGENT',
    /**
     * @value Using A2A protocol. Accessible via AI Chat.
     * @description Helper text shown under the "Connect a third-party agent" option in the agent creation form's agent type radio group.
     */
    CONNECT_THIRD_PARTY_AGENT_DESCRIPTION = 'AGENT_HUB_AGENTS.CONNECT_THIRD_PARTY_AGENT_DESCRIPTION',
    /**
     * @value Conversation Starters
     * @description Title of the conversation starters section in the Agent Hub admin
     */
    CONVERSATION_STARTERS = 'AGENT_HUB_SEARCH.CONVERSATION_STARTERS',
    /**
     * @value Suggested questions shown at the start of a chat to help users know what they can ask.
     * @description Description of the conversation starters section in the Agent Hub admin
     */
    CONVERSATION_STARTERS_DESCRIPTION = 'AGENT_HUB_SEARCH.CONVERSATION_STARTERS_DESCRIPTION',
    /**
     * @value Are you sure you want to delete this conversation starter?
     * @description Title of the dialog displayed when the user is about to delete a conversation starter field in the Agent Hub
     */
    CONVERSATION_STARTER_DELETE_CONFIRM = 'AGENT_HUB_SEARCH.CONVERSATION_STARTER_DELETE_CONFIRM',
    /**
     * @value Starter #%INDEX%
     * @description Label of the conversation starters fields in the Agent Hub admin.
     */
    CONVERSATION_STARTER_LABEL = 'AGENT_HUB_SEARCH.CONVERSATION_STARTER_LABEL',
    /**
     * @value Write the message answered by the agent
     */
    CUSTOM_MESSAGE_DESCRIPTION = 'AGENT_HUB_SEARCH.CUSTOM_MESSAGE_DESCRIPTION',
    /**
     * @value Visible to all allowed users
     */
    EXPERTISE_TITLE_HELPER = 'AGENT_HUB_SEARCH.EXPERTISE_TITLE_HELPER',
    /**
     * @value When a user selects this agent, system will open the provided link in a new browser tab (or the external app, if supported).
     * @description First part of the text displayed within the "How it works" section of the Agent Hub when creating an external agent
     */
    EXTERNAL_AGENT_HOW_IT_WORKS_FIRST_INFO = 'AGENT_HUB_SEARCH.EXTERNAL_AGENT_HOW_IT_WORKS_FIRST_INFO',
    /**
     * @value The conversation happens in the external product. LumApps doesn’t control that interface or the agent’s responses.
     * @description Second part of the text displayed within the "How it works" section of the Agent Hub when creating an external agent
     */
    EXTERNAL_AGENT_HOW_IT_WORKS_SECOND_INFO = 'AGENT_HUB_SEARCH.EXTERNAL_AGENT_HOW_IT_WORKS_SECOND_INFO',
    /**
     * @value Paste the URL that opens the agent in the external service.
     * @description Helper describing the "External Link" section in the new agent form
     */
    EXTERNAL_LINK_HELPER = 'AGENT_HUB_SEARCH.EXTERNAL_LINK_HELPER',
    /**
     * @value External system
     * @description Agent Hub "Created by" filter option: agents listed from an external system (external agents).
     */
    EXTERNAL_SYSTEM = 'AGENT_HUB_AGENTS.EXTERNAL_SYSTEM',
    /**
     * @value Global Guidelines & Guardrails for agents
     * @description Page title for the compliance/guidelines admin page. Replaces "Guidelines and Compliance". Also used in the compliance message banner on the agents  list page.
     */
    GUIDELINES_AND_GUARDRAILS_FOR_AGENTS = 'AGENT_HUB_COMPLIANCE.GUIDELINES_AND_GUARDRAILS_FOR_AGENTS',
    /**
     * @value This agent is provided by LumApps. You can rename it, change its icon, and define who can access it.
     * @description Info message displayed at the bottom of the edition form for native agents.
     */
    NATIVE_AGENT_INFO = 'AGENT_HUB_SEARCH.NATIVE_AGENT_INFO',
    /**
     * @value e.g. You are a helpful HR assistant. Answer with short sentences and use bullet points. Do not use jargon.
     */
    PROMPT_PLACEHOLDER = 'AGENT_HUB_SEARCH.PROMPT_PLACEHOLDER',
    /**
     * @value Provided by LumApps
     * @description Label shown instead of the author for native (built-in) agents in the agent list.
     */
    PROVIDED_BY_LUMAPPS = 'AGENT_HUB_SEARCH.PROVIDED_BY_LUMAPPS',
    /**
     * @value Provide custom answer
     * @description "Provide custom answer" type of AI agent mission.
     */
    PROVIDE_CUSTOM_ANSWER = 'AGENT_HUB_SEARCH.PROVIDE_CUSTOM_ANSWER',
    /**
     * @value Set overarching directives to enforce guardrails, consistency, tone, and compliance across all your agents.
     * @description Description text explaining the purpose of the compliance/guidelines page. Displayed in the compliance message banner on the agents list page.
     */
    SET_OVERARCHING_DIRECTIVES_TO_ENFORCE_GUARDRAILS = 'AGENT_HUB_COMPLIANCE.SET_OVERARCHING_DIRECTIVES_TO_ENFORCE_GUARDRAILS',
    /**
     * @value Specialization
     * @description Title of the "Specialization" section of the agent creation and edition form
     */
    SPECIALIZATION = 'AGENT_HUB_AGENTS.SPECIALIZATION',
    /**
     * @value Describe what this agent specializes in. LumApps uses this information to decide when this agent is the best match for a user’s request.
     * @description Description of the "Specialization" section of the agent creation and edition form.
     */
    SPECIALIZATION_DESCRIPTION = 'AGENT_HUB_AGENTS.SPECIALIZATION_DESCRIPTION',
    /**
     * @value Describe the questions, tasks, and situations this agent should handle.
     * @description Helper shown un der the Specialization field of the agent creation and edition field.
     */
    SPECIALIZATION_HELPER = 'AGENT_HUB_AGENTS.SPECIALIZATION_HELPER',
    /**
     * @value When should this agent be used?
     * @description Label for the field in the "Specialization" section of the agent creation and edition form.
     */
    SPECIALIZATION_LABEL = 'AGENT_HUB_AGENTS.SPECIALIZATION_LABEL',
    /**
     * @value Example: Questions about payroll, benefits, vacation policies, parental leave, and enrollment.
     * @description Placeholder shown on the "Specialization" field of the agent creation and edition form.
     */
    SPECIALIZATION_PLACEHOLDER = 'AGENT_HUB_AGENTS.SPECIALIZATION_PLACEHOLDER',
    /**
     * @value System prompt
     */
    SYSTEM_PROMPT = 'AGENT_HUB_SEARCH.SYSTEM_PROMPT',
    /**
     * @value Save and continue
     * @description Confirm button of the dialog shown before testing an A2A agent connection: saves the agent, then continues to authorization.
     */
    TEST_CONNECTION_CONFIRM_ACTION = 'AGENT_HUB_AGENTS.TEST_CONNECTION_CONFIRM_ACTION',
    /**
     * @value Testing requires the agent to be saved first. If the agent is published, these changes may affect the experience available to users. Next, you'll be redirected to the connector provider to sign in and authorize the connection. Once completed, LumApps will test it automatically.
     * @description Body of the confirm dialog shown before testing an A2A agent connection, explaining that the agent is saved and the user is redirected to authorize the connector.
     */
    TEST_CONNECTION_CONFIRM_DESC = 'AGENT_HUB_AGENTS.TEST_CONNECTION_CONFIRM_DESC',
    /**
     * @value Save changes and continue to authorization?
     * @description Title of the confirm dialog shown when testing an A2A agent connection (saving is required first).
     */
    TEST_CONNECTION_CONFIRM_TITLE = 'AGENT_HUB_AGENTS.TEST_CONNECTION_CONFIRM_TITLE',
    /**
     * @value We are connecting to the agent server and getting agent's details.
     * @description Body of the progress dialog shown while LumApps connects to an A2A agent server during a connection test.
     */
    TEST_CONNECTION_CONNECTING_DESC = 'AGENT_HUB_AGENTS.TEST_CONNECTION_CONNECTING_DESC',
    /**
     * @value Connecting…
     * @description Title of the progress dialog shown while LumApps connects to an A2A agent server during a connection test.
     */
    TEST_CONNECTION_CONNECTING_TITLE = 'AGENT_HUB_AGENTS.TEST_CONNECTION_CONNECTING_TITLE',
    /**
     * @value Check the Agent Card URL and connector's details and try again
     * @description Body of the failure dialog shown when an A2A agent connection test fails, telling the admin to check the Agent Card URL and connector settings.
     */
    TEST_CONNECTION_FAILED_DESC = 'AGENT_HUB_AGENTS.TEST_CONNECTION_FAILED_DESC',
    /**
     * @value Authorization completed successfully.
     * @description Body of the success dialog shown after an A2A agent connection test completes successfully.
     */
    TEST_CONNECTION_SUCCESS_DESC = 'AGENT_HUB_AGENTS.TEST_CONNECTION_SUCCESS_DESC',
    /**
     * @value Ready to use
     * @description Title of the success dialog shown after an A2A agent connection test completes successfully.
     */
    TEST_CONNECTION_SUCCESS_TITLE = 'AGENT_HUB_AGENTS.TEST_CONNECTION_SUCCESS_TITLE',
    /**
     * @value This agent has more than %NUMBER% tools. A large tool set can make responses less focused, so consider keeping only the most relevant ones.
     * @description Warning showed when too many tools have been added to an agent.
     */
    TOO_MANY_TOOLS_WARNING = 'AGENT_HUB_AGENTS.TOO_MANY_TOOLS_WARNING',
    /**
     * @value User Experience
     * @description Title of the "user experience" section of the back office page for creating and editing agents.
     */
    USER_EXPERIENCE = 'AGENT_HUB_AGENTS.USER_EXPERIENCE',
    /**
     * @value Configure how employees discover and interact with this agent.
     * @description Description of the "user experience" section of the back office page for creating and editing agents.
     */
    USER_EXPERIENCE_DESCRIPTION = 'AGENT_HUB_AGENTS.USER_EXPERIENCE_DESCRIPTION',
    /**
     * @value Workspace admins
     * @description Agent Hub "Created by" filter option: agents created by workspace administrators (non-native agents).
     */
    WORKSPACE_ADMINS = 'AGENT_HUB_AGENTS.WORKSPACE_ADMINS',
}
